shadow$provide[475] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Node:{enumerable:true, get:function() {
  return Node;
}}});
var require$_DOT__SLASH_graph = require("./graph");
var require$_DOT__SLASH_outlet = require("./outlet");
class Node {
  static initClass() {
    this.index = 0;
  }
  static id(_name) {
    return ++Node.index;
  }
  constructor(owner, outlets) {
    this.owner = owner;
    this.graph = null;
    this.inputs = [];
    this.outputs = [];
    this.all = [];
    this.outlets = null;
    this.id = Node.id();
    this.setOutlets(outlets);
  }
  getIn(name) {
    return Array.from(this.inputs).filter(outlet => outlet.name === name)[0];
  }
  getOut(name) {
    return Array.from(this.outputs).filter(outlet => outlet.name === name)[0];
  }
  get(name) {
    return this.getIn(name) || this.getOut(name);
  }
  setOutlets(outlets) {
    if (outlets != null) {
      let outlet;
      if (this.outlets == null) {
        this.outlets = {};
        for (outlet of Array.from(outlets)) {
          if (!(outlet instanceof require$_DOT__SLASH_outlet.Outlet)) {
            outlet = require$_DOT__SLASH_outlet.Outlet.make(outlet);
          }
          this._add(outlet);
        }
        return;
      }
      const hash = outlet => [outlet.name, outlet.inout, outlet.type].join("-");
      const match = {};
      for (outlet of Array.from(outlets)) {
        match[hash(outlet)] = true;
      }
      for (let key in this.outlets) {
        outlet = this.outlets[key];
        key = hash(outlet);
        if (match[key]) {
          match[key] = outlet;
        } else {
          this._remove(outlet);
        }
      }
      for (outlet of Array.from(outlets)) {
        const existing = match[hash(outlet)];
        if (existing instanceof require$_DOT__SLASH_outlet.Outlet) {
          this._morph(existing, outlet);
        } else {
          if (!(outlet instanceof require$_DOT__SLASH_outlet.Outlet)) {
            outlet = require$_DOT__SLASH_outlet.Outlet.make(outlet);
          }
          this._add(outlet);
        }
      }
      this;
    }
    return this.outlets;
  }
  connect(node, empty, force) {
    let dest, dests, hint, source, type;
    const outlets = {};
    const hints = {};
    const typeHint = outlet => type + "/" + outlet.hint;
    for (dest of Array.from(node.inputs)) {
      let list;
      if (!force && dest.input) {
        continue;
      }
      ({type} = dest);
      hint = typeHint(dest);
      if (!hints[hint]) {
        hints[hint] = dest;
      }
      outlets[type] = list = outlets[type] || [];
      list.push(dest);
    }
    let sources = this.outputs;
    sources = sources.filter(outlet => !(empty && outlet.output.length));
    for (source of Array.from(sources.slice())) {
      ({type} = source);
      hint = typeHint(source);
      dests = outlets[type];
      if (dest = hints[hint]) {
        source.connect(dest);
        delete hints[hint];
        dests.splice(dests.indexOf(dest), 1);
        sources.splice(sources.indexOf(source), 1);
      }
    }
    if (!sources.length) {
      return this;
    }
    for (source of Array.from(sources.slice())) {
      ({type} = source);
      dests = outlets[type];
      if (dests && dests.length) {
        source.connect(dests.shift());
      }
    }
    return this;
  }
  disconnect(_node) {
    let outlet;
    for (outlet of Array.from(this.inputs)) {
      outlet.disconnect();
    }
    for (outlet of Array.from(this.outputs)) {
      outlet.disconnect();
    }
    return this;
  }
  _key(outlet) {
    return [outlet.name, outlet.inout].join("-");
  }
  _add(outlet) {
    const key = this._key(outlet);
    if (outlet.node) {
      throw new Error("Adding outlet to two nodes at once.");
    }
    if (this.outlets[key]) {
      throw new Error(`Adding two identical outlets to same node. (${key})`);
    }
    outlet.node = this;
    if (outlet.inout === require$_DOT__SLASH_graph.Graph.IN) {
      this.inputs.push(outlet);
    }
    if (outlet.inout === require$_DOT__SLASH_graph.Graph.OUT) {
      this.outputs.push(outlet);
    }
    this.all.push(outlet);
    return this.outlets[key] = outlet;
  }
  _morph(existing, outlet) {
    let key = this._key(outlet);
    delete this.outlets[key];
    existing.morph(outlet);
    key = this._key(outlet);
    return this.outlets[key] = outlet;
  }
  _remove(outlet) {
    const key = this._key(outlet);
    if (outlet.node !== this) {
      throw new Error("Removing outlet from wrong node.");
    }
    outlet.disconnect();
    outlet.node = null;
    delete this.outlets[key];
    if (outlet.inout === require$_DOT__SLASH_graph.Graph.IN) {
      this.inputs.splice(this.inputs.indexOf(outlet), 1);
    }
    if (outlet.inout === require$_DOT__SLASH_graph.Graph.OUT) {
      this.outputs.splice(this.outputs.indexOf(outlet), 1);
    }
    this.all.splice(this.all.indexOf(outlet), 1);
    return this;
  }
}
Node.initClass();

};